<template>
  <div class="carNumOrder">
    <div class="car-num-tab">
      <van-row >
        <van-col span="8">
            <div :class="carNumColA" @click="changeCarNum(carNumList[1],'A')">{{carNumList[1]}}</div>
        </van-col>
        <van-col span="8">
            <div :class="carNumColB" @click="changeCarNum(carNumList[0],'B')">{{carNumList[0]}}</div>
        </van-col>
        <van-col span="8">
            <div :class="carNumColC" @click="changeCarNum(carNumList[2],'C')">{{carNumList[2]}}</div>
        </van-col>
      </van-row>
    </div>
    <a @click="goOrderCarPay">其他车辆缴费></a>
    <div class="order-view" v-if="orderShow">
      <div class="order-money">
      <div class="order-money-round">
        <p class="money-unit">当前费用(元)</p>
        <p class="money">{{orderDetails.needPay>0?orderDetails.needPay:0.00}}</p>
      </div>
    </div>
    <div class="order-info">
      <p>停车时长:{{orderDetails.parkingTime}}</p>
      <van-cell-group>
        <van-cell title="入场时间" :value="orderDetails.startTime" />
        <van-cell title="停车场" :value="orderDetails.parkName" />
      </van-cell-group>
    </div>

    <van-button v-if="orderDetails.shouldPay>0" class="bt-qurey" color="#f47b20" @click="goPay">去缴费</van-button>
    <van-button v-if="orderDetails.type==0&&orderDetails.shouldPay==0" class="bt-qurey" color="#f47b20" @click="goPrePay">预交费</van-button>
    </div>

  </div>
</template>

<script>
export default {
  name: "carNumOrder",
  data() {
    return {
      title: "",
      active: "2",
      carNum: "",
      carNumList:[],
      carNumColA:"car-num-col",
      carNumColB:"car-num-col-click",
      carNumColC:"car-num-col",
      orderShow:false,
      orderDetails:{
        shouldPay:"",
        needPay:"",
        parkingTime:"",
        startTime:"",
        parkName:"",
        orderId:"",
        type:"",
        carNum:"",
        companyId:""
      },
    };
  },
  methods: {
    onClickLeft() {
      console.log("返回");
      this.$router.push("/menu");
    },
    goPay(){
      this.$router.push(
        {
          name:"orderDetails",
          query:{
            shouldPay:this.orderDetails.shouldPay,
            needPay:this.orderDetails.needPay,
            parkingTime:this.orderDetails.parkingTime,
            startTime:this.orderDetails.startTime,
            parkName:this.orderDetails.parkName,
            orderId:this.orderDetails.orderId,
            type:this.orderDetails.type,
            companyId:this.orderDetails.companyId,
            carNum:this.orderDetails.carNum,
            payLevel:0
          }
        }
      );
    },

    goPrePay(){
      if(this.orderDetails.needPay<0){
        this.$toast("存在未用完预交费金额");
        return;
      }
      this.$router.push(
        {
          name:"prePay",
          query:{
            orderInfo:this.orderDetails,
          }
        }
      );
    },
    goOrderCarPay(){
       this.$router.push("queryOrder" );
    },
    changeCarNum(num,choose){
      switch(choose){
        case "A":
          this.carNumColA="car-num-col-click";
          this.carNumColB="car-num-col";
          this.carNumColC="car-num-col";
          break;
        case "B":
          this.carNumColA="car-num-col";
          this.carNumColB="car-num-col-click";
          this.carNumColC="car-num-col";
          break;
        case "C":
          this.carNumColA="car-num-col";
          this.carNumColB="car-num-col";
          this.carNumColC="car-num-col-click";
          break;

      }
      this.orderShow=false;
      this.queryBycarNum(num);
    },
    //获取订单信息
    queryBycarNum(carNum) {
      console.log(carNum);
      if(carNum==""||carNum==null){
        return;
      }
      let params = {
        carNum: carNum
      };
      console.log(this.carNum);
      this.$http
        .post(this.$api.queryWechatOrder, params)
        .then(data => {
          if (data.code == 200) {
            this.orderDetails.shouldPay=data.data.shouldPay;
            this.orderDetails.needPay=data.data.needPay;
            this.orderDetails.parkingTime=data.data.parkingTime;
            this.orderDetails.startTime=data.data.order.startTime;
            this.orderDetails.parkName=data.data.order.parkName;
            this.orderDetails.orderId=data.data.order.id;
            this.orderDetails.type=data.data.type;
            this.orderDetails.companyId=data.data.order.companyId;
            this.orderDetails.carNum=carNum
            this.orderShow=true;
          }
          else{
            this.$toast("暂无在停订单");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCarNumList(){
      this.carNumList=this.$route.query.carNumList;
      console.log(this.carNumList);
    },
  },
  created() {

  },
  mounted(){
    this.getCarNumList();
    this.queryBycarNum(this.carNumList[0]);
  }
};
</script>

<style scoped>
.carNumOrder {
  min-height: 100%;
  height: 100%;
  width: 100%;
  max-width: 100%;
  /* background-color: #e8e9eb; */
  background-color: #FFFFFF;
  float: left;
}
.car-num-tab{
    width: 90%;
    height: 40px;
    margin-left: 5%;
    margin-top:20%;
}
.car-num-col{
    height: 30px;
    width: 100%;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    border: 1px solid #FFF;
    background-color: #1e83ef;
    color: #FFFFFF;

}
.car-num-col-click{
    height: 30px;
    width: 100%;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    border: 1px solid #FFF;
    background-color: #1e83ef;
    color: #FFFFFF;
    transform:scale(1.3,1.3);

}
.carNumOrder a{
    float: right;
    color: #0000ff;
    margin-right: 5%;
    font-size: 14px;
}
.order-money{
    height: 150px;
    width: 100%;
    float: left;
    text-align: center;
    background-color: #FFFFFF;
}
.order-money-round{
    height: 128px;
    width: 128px;
    border:2px solid #f47b20;
    margin: 0 auto;
    border-radius: 50%;
}
.money-unit{
    margin-top: 30px;
}
.money{
    font-size: 30px;
    margin: 0;
    padding: 0;
    color: red;
}
.order-info{
    height: 200px;
    width: 90%;
    float: left;
    margin-left: 5%;
}
.order-info p{
     text-align: center;
     font-size: 20px;
}

.bt-qurey {
  width: 90%;
  margin-left: 5%;
  margin-top: 16px;
  border-radius: 5px;
  height: 40px;
  /* position: fixed;
  display: block; */
}

</style>



// WEBPACK FOOTER //
// src/components/order/carNumOrder.vue